/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutActionMetadata } from './rolloutActionMetadata';
import { RolloutNotificationDetails } from './rolloutNotificationDetails';
import { RolloutActionType } from './rolloutActionType';
import { RolloutTaskDetails } from './rolloutTaskDetails';


export interface RolloutTaskActionResponse { 
    /**
     * Created user email ID.
     */
    created_by?: string;
    /**
     * Created Date Time
     */
    created_ts?: Date;
    /**
     * Updated user email ID.
     */
    updated_by?: string;
    /**
     * Updated Date Time
     */
    updated_ts?: Date;
    type?: RolloutActionType;
    task?: RolloutTaskDetails;
    /**
     * List of notifications.
     */
    notifications?: Array<RolloutNotificationDetails>;
    metadata?: RolloutActionMetadata;
}
export namespace RolloutTaskActionResponse {
}


